import React from "react";
import { Link } from "react-router-dom";
import { Tag } from "antd";


import { getIconUrl } from "../../../../../services/asset";
import { stringifyURI } from "../../../../../services";

import NotificationSelector from "./NotificationSelector";
import styles from "./savedSearchItem.scss";
import {
  PageRoute,
  QueryParam
} from "../../../../../models";
import {
  mapCategoryToHr,
  mapModuleToHr
} from "../../../../../routes/LanguageMapper";

// Link of a saved search: the API returns the seo path of its criteria
// ("/auto-moto/osobni-automobili/bmw/x5/pretraga"), the query holds the criteria.
const buildSearchUrl = item => {
  // Include text field in criteria if it exists at the top level
  const criteriaWithText = item.text
    ? { ...item.criteria, text: item.text }
    : item.criteria;

  const query = stringifyURI(criteriaWithText, QueryParam.searchQuery);

  if (item.seoPath) {
    return `${item.seoPath}${query}`;
  }

  return `${item.module ? `/${mapModuleToHr(item.module)}` : ""
    }${item.category ? `/${mapCategoryToHr(item.category, item.module)}` : ""
    }${PageRoute.search}${query}`;
};

const SavedSearchItem = ({ item, onDelete, onNotificationChange }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.date}>{item.formattedCreatedTime}</div>
      <div className={styles.titleWrapper}>
        <Link
          title={item.Name}
          to={buildSearchUrl(item)}
          className={styles.name}
        >
          {item.name}
        </Link>
        <span
          role="button"
          tabIndex={0}
          className={styles.deleteIcon}
          onClick={() => onDelete(item.id)}
        >
          <img
            alt={"Više"}
            src={getIconUrl("garbage.svg")}
          />
        </span>
      </div>
      <div>
        {item.tags.map((tag) => <Tag key={tag} className={styles.itemTag}>{tag}</Tag>)}
      </div>

      <NotificationSelector
        value={item.notifyFrequency}
        onChange={value => onNotificationChange(item, value)}
      />
    </div>
  );
};

export default SavedSearchItem;



// WEBPACK FOOTER //
// ./src/containers/SavedSearchPage/ListSavedSearch/ListSavedSearchMobile/SavedSearchItem/index.tsx